import { Config, Features } from '../../shared/types/ast';
import { useState, useLayoutEffect } from 'react';

const readConfig = () => {
    if (document) {
        const horseshoeConfig = document.getElementById('horseshoe-config');
        if (horseshoeConfig && horseshoeConfig.innerHTML) {
            return JSON.parse(horseshoeConfig.innerHTML) as Config;
        }
    }
    return;
};
let config = readConfig();

export const getConfig = () => {
    if (!config) {
        config = readConfig();
    }
    return config;
};

export const useFeature = () => {
    const [features, setFeature] = useState<Features>();

    const config = getConfig();
    useLayoutEffect(() => {
        setFeature(config?.features);
    }, [config]);

    return features;
};
